import script from "./AddImageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddImageModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddImageModal.vue?vue&type=style&index=0&id=4619f7b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4619f7b6"]])

export default __exports__